import { useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { EmergencyInstructionForm } from "~/components/form/health-profile/EmergencyInstructionForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useProfile } from "~/providers/ProfileProvider";

export default function EditInstruction() {
    const { id }: { id: string } = useLocalSearchParams();
    const { instructions } = useProfile();
    const instruction = useMemo(() => instructions.find((i) => i.id === id), [id, instructions]);

    if (!instruction) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="profile">
            <EmergencyInstructionForm instruction={instruction} asRoute />
        </Authorize>
    );
}
